import {Component, Input} from '@angular/core';
import {ActivityStatus, ActivityStatusLabels} from '../../domain/activity-status.model';

@Component({
  selector: 'cm-activity-status-circle-plate',
  template: `
    <!--<span class="status-circle"-->
      <!--[ngClass]="{-->
        <!--'status-circle&#45;&#45;green': status === ActivityStatus.ACTIVE-->
       <!--, 'status-circle&#45;&#45;blue': status === ActivityStatus.READY-->
       <!--, 'status-circle&#45;&#45;orange': status === ActivityStatus.DRAFT-->
       <!--, 'status-circle&#45;&#45;gray': status === ActivityStatus.ARCHIVED-->
       <!--, 'status-circle&#45;&#45;red': status === ActivityStatus.INACTIVE}">-->
      <!--<i class="fas fa-circle"></i>-->
  <!--</span>-->
    <span>
      {{ActivityStatusLabels[status]}}
      <!--<span *ngIf="test">- test</span>-->
  </span>
  `
})
export class ActivityStatusCirclePlateComponent {

  @Input()
  public test: boolean;
  @Input()
  public status: ActivityStatus;

  public ActivityStatus = ActivityStatus;
  public ActivityStatusLabels = ActivityStatusLabels;

}
